import * as React from 'react'

import {ErrorState} from './types'

export const emptyErrorState: ErrorState = {
  valid: false,
  invalidFields: [],
  errors: {},
  warnings: {},
}

export interface ErrorUpdate {
  (s: ErrorState): void
}

export interface ErrorContext {
  context: ErrorState
  update: (updater: ErrorUpdate) => void
}

export default React.createContext<ErrorContext>({
  context: emptyErrorState,
  update: () => void 0,
})
